/* BH CUSTOM: Bewertungs-E-Mail Opt-in */

(function () {
  'use strict';

  if (window.__reviewConsentInitialized) return;
  window.__reviewConsentInitialized = true;

  var savingConsent = false;
  var pendingSave = null;

  function setStatus(text, isError) {
    document
      .querySelectorAll('[data-review-consent-status]')
      .forEach(function (element) {
        element.textContent = text || '';
        element.style.color = isError ? '#b42318' : '#667085';
      });
  }

  function disableCheckboxes(disabled) {
    document
      .querySelectorAll('[data-review-consent]')
      .forEach(function (checkbox) {
        checkbox.disabled = disabled;
      });
  }

  function syncCheckboxes(value) {
    document
      .querySelectorAll('[data-review-consent]')
      .forEach(function (checkbox) {
        checkbox.checked = value === 'yes';
      });
  }

  async function saveReviewConsent(value) {
    savingConsent = true;
    disableCheckboxes(true);
    setStatus('Auswahl wird gespeichert …', false);

    try {
      var root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      var response = await fetch(
        root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              review_consent_v1: value
            }
          })
        }
      );

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      await response.json();
      syncCheckboxes(value);

      if (value === 'yes') {
        setStatus('✓ Einwilligung gespeichert', false);
      } else {
        setStatus('Einwilligung entfernt', false);
      }

      return true;

    } catch (error) {
      console.error(
        'Bewertungs-Einwilligung konnte nicht gespeichert werden:',
        error
      );

      setStatus(
        'Die Auswahl konnte nicht gespeichert werden. Bitte versuche es erneut.',
        true
      );

      return false;

    } finally {
      savingConsent = false;
      disableCheckboxes(false);
    }
  }

  document.addEventListener('change', function (event) {
    var checkbox =
      event.target.closest &&
      event.target.closest('[data-review-consent]');

    if (!checkbox) return;

    var oldValue = checkbox.checked ? 'no' : 'yes';
    var newValue = checkbox.checked ? 'yes' : 'no';

    pendingSave = saveReviewConsent(newValue);

    pendingSave.then(function (success) {
      if (!success) {
        syncCheckboxes(oldValue);
      }

      pendingSave = null;
    });
  });

  document.addEventListener('click', async function (event) {
    var checkoutButton =
      event.target.closest &&
      event.target.closest(
        '.checkout-buttons a, .checkout-buttons button[name="checkout"]'
      );

    if (!checkoutButton) return;
    if (!savingConsent || !pendingSave) return;

    var checkoutUrl = checkoutButton.href || null;

    event.preventDefault();
    setStatus('Einwilligung wird gespeichert …', false);

    try {
      await pendingSave;
    } catch (error) {
      console.error(error);
    }

    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    } else {
      checkoutButton.click();
    }
  });

})();